export default __webpack_public_path__ + "static/media/expl_09_DE.86c9bf30.png";